import request from '../index';
/** 和人事管理相关的接口 **/

/** 
* User
* @params {number} data.custom 
* @params {string} data.entryTime 入职时间
* @params {string} data.firstLevelDepartment 一级部门
* @params {number} data.id 
* @params {boolean} data.isDL 是否部门主管
* @params {string} data.jobNumber 工号
* @params {string} data.nickName 昵称
* @params {string} data.notes 备注
* @params {string} data.password 登录密码
* @params {number} data.pid 
* @params {string} data.post 职位
* @params {string} data.reportTo 直属领导
* @params {string} data.secondaryDepartment 二级部门
* @params {number} data.structureId 
* @params {string} data.username 登录账户
*/

/** 
* Structure
* @params {array} data.children 
* @params {number} data.custom 
* @params {number} data.id 
* @params {number} data.pid 
* @params {string} data.structureName 
* @params {array} data.userList 
*/

/** 
* 删除组织架构
* @params {array} ids
*/
export const deleteStructure = (data) => request.delete('/api-qc/deleteStructure', { data });

/** 
* 删除用户
* @params {array} ids
*/
export const deleteUser = (data) => request.delete('/api-qc/deleteUser', { data });

/** 
* 获得组织架构
* @params {number} params.id id
*/
export const getStructure = (params) => request.get('/api-qc/getStructure', { params });

/** 
* 获得账户列表
* @params {number} params.id 登录账户Id
*/
export const getUserList = (params) => request.get('/api-qc/getUserList', { params });

/** 
* 登陆
*/
export const login = (data) => request.post('/api-qc/login', data);

/** 
* 添加or更新账户
* @params {User} user
*/
export const saveOrUpdateUser = (data) => request.post('/api-qc/saveOrUpdateUser', data);

/** 
* 添加or更新组织架构
* @params {Structure} structure
*/
export const saveStructure = (data) => request.post('/api-qc/saveStructure', data);
